<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            CONTRATO -
                            <strong
                                >{{ contrato.vcCodigoEstruturado }} -
                                {{
                                    contrato.fornecedor
                                        ? contrato.fornecedor.nome
                                        : ''
                                }}</strong
                            >
                            <b-badge variant="warning" class="ml-2">{{
                                operacao
                            }}</b-badge>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <b-tabs pills card vertical v-model="tabIndex">
                            <b-tab title="Dados Gerais" active class="pb-0">
                                <contrato-dados-gerais
                                    :contrato="contrato"
                                ></contrato-dados-gerais>
                            </b-tab>
                            <b-tab title="Itens de Contrato" class="pb-0">
                                <itens-contrato
                                    :contrato="contrato"
                                    :dataServicos="dataServicos"
                                ></itens-contrato>
                            </b-tab>
                            <b-tab title="Documentos" class="pb-0">
                                <documentos
                                    :contrato="contrato"
                                    :dataServicos="dataServicos"
                                ></documentos>
                            </b-tab>
                            <b-tab title="Fases do Contrato" class="pb-0">
                                <fases-contrato
                                    :contrato="contrato"
                                    :dataServicos="dataServicos"
                                ></fases-contrato>
                            </b-tab>
                            <b-tab title="Dotações Orçamentárias" class="pb-0">
                                <dotacoes-orcamentarias
                                    :contrato="contrato"
                                ></dotacoes-orcamentarias>
                            </b-tab>
                            <b-tab
                                title="Comprometimentos"
                                class="pb-0"
                                v-if="
                                    !contratoElaboracao &&
                                    !aditivoContratoIniciado
                                "
                            >
                                <comprometimentos
                                    :contrato="contrato"
                                    :dataServicos="dataServicos"
                                ></comprometimentos>
                            </b-tab>
                            <b-tab
                                title="Apostilamento"
                                class="pb-0"
                                v-if="
                                    !contratoElaboracao &&
                                    !aditivoContratoIniciado
                                "
                            >
                                <contrato-apostilamentos
                                    :contrato="contrato"
                                ></contrato-apostilamentos>
                            </b-tab>
                            <b-tab
                                title="Ocorrências Internas"
                                class="pb-0"
                                v-if="
                                    !contratoElaboracao &&
                                    !aditivoContratoIniciado
                                "
                            >
                                <ocorrencias-internas
                                    :contrato="contrato"
                                ></ocorrencias-internas>
                            </b-tab>
                            <b-tab
                                title="Penalidades"
                                class="pb-0"
                                v-if="
                                    !contratoElaboracao &&
                                    !aditivoContratoIniciado
                                "
                            >
                                <penalidades :contrato="contrato"></penalidades>
                            </b-tab>
                            <b-tab
                                title="Avaliações"
                                class="pb-0"
                                v-if="contrato.avaliacoes"
                            >
                                <avaliacoes :contrato="contrato"></avaliacoes>
                            </b-tab>
                        </b-tabs>
                    </b-card-body>
                    <b-card-footer>
                        <b-button variant="danger" @click.stop="voltar()">
                            <span>
                                <i class="fa fa-history mr-2"></i> Voltar
                            </span>
                        </b-button>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import ContratoDadosGerais from './ContratoDadosGerais'
import ItensContrato from './itensContrato/ItensContrato'
import Documentos from './documentos/Documentos'
import FasesContrato from './fasesContrato/FasesContrato'
import DotacoesOrcamentarias from './dotacoesOrcamentarias/DotacoesOrcamentarias'
import Comprometimentos from './comprometimentos/Comprometimentos'
import ContratoApostilamentos from './apostilamento/ContratoApostilamentos'
import OcorrenciasInternas from './ocorrencias/OcorrenciasInternas'
import { situacaoContrato } from './SituacaoContrato'
import Penalidades from './penalidades/Penalidades'
import Avaliacoes from './avaliacoes/Avaliacoes'

export default {
    props: {
        dataServicos: {
            type: Object
        },

        rotaListagem: {
            type: String
        }
    },

    components: {
        ContratoDadosGerais,
        ItensContrato,
        Documentos,
        FasesContrato,
        DotacoesOrcamentarias,
        Comprometimentos,
        OcorrenciasInternas,
        ContratoApostilamentos,
        Penalidades,
        Avaliacoes
    },

    data() {
        return {
            contrato: {},
            dadosRm: {},
            operacao: 'DETALHAR',
            tabIndex: 0
        }
    },

    methods: {
        voltar() {
            this.$router.push({ name: this.rotaListagem })
        },

        obterContrato() {
            this.$store.dispatch('addRequest')
            this.dataServicos
                .obterPorId(this.$route.params.contratoId)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.contrato = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivoContratoIniciado() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        }
    },

    created() {
        this.obterContrato()
    }
}
</script>
